import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import ContactHero from "./sections/ContactHero";
import Location from "./sections/Location";
import ContactInquiryForm from "./sections/ContactInquiryForm";
import Serviceareas from "./sections/Serviceareas";
import Appointment from "./sections/Appointment";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <ContactHero />
      <Location />
      <ContactInquiryForm />
      <Serviceareas />
      <Appointment />
      <Footer />
    </div>;
}